import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import {
  SecondaryProfilesErrorModalView,
  SecondaryProfilesErrorModalViewProps
} from './SecondaryProfilesErrorModal.view';
import { ConnectProfileOAuthModalType, ConnectProfileOAuthType, ErrorModalType } from '../Profiles.controller';
import { SocialOAuthContext, StartSocialOAuthMutationFn } from '../../../../models/graphql';
import { showToast } from '../../../../helpers/showToast';
import { socialOAuthVar } from '../../../../providers/AppProvider';

export type SecondaryProfilesErrorModalControllerProps = Omit<
  SecondaryProfilesErrorModalViewProps,
  'cancelConnect' | 'loading' | 'oAuthConnectObject'
> & {
  // extend your SecondaryProfilesErrorModalViewProps
  oAuthContext: ConnectProfileOAuthModalType;
  setErrorModal: Dispatch<SetStateAction<ErrorModalType | null>>;
  loading: boolean;
  modalError: JSX.Element | string;
  startSocialOAuth: StartSocialOAuthMutationFn;
};

export const SecondaryProfilesErrorModalController = (
  props: SecondaryProfilesErrorModalControllerProps
): JSX.Element => {
  // Put All your methods and logic here
  const [loading, setLoading] = useState(false);

  const oAuthConnectObject: ConnectProfileOAuthType = {
    ...props.oAuthContext,
    startSocialOAuth: props.startSocialOAuth,
    setLoading,
    socialOAuthContext: SocialOAuthContext.CONNECT
  };

  const cancelConnect = (): void => {
    socialOAuthVar(null);
    props.setErrorModal(null);
  };

  useEffect(() => {
    if (props.modalError) {
      showToast({
        severity: 'error',
        summary: 'Profile not connected',
        detail: props.modalError
      });
    }
  }, [props.modalError]);

  const viewProps: SecondaryProfilesErrorModalViewProps = {
    ...props,
    cancelConnect,
    loading: props.loading || loading,
    oAuthConnectObject
  };

  return <SecondaryProfilesErrorModalView {...viewProps} />;
};
